import React, { useEffect, useRef, useState, useContext } from 'react';
import query from 'jquery';
import { Link, NavLink, useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import useCustomerCreate from '../../../hooks/useRegisterCustomer';

import JWTContext from '../../../context/JWTContext';
import axios from '../../../utils/axios';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { DEFAULT_COUNTRY_CODE } from '../../../constants';

const schema = yup
    .object({
        email: yup.string().email().required(),
        password: yup.string().required(),
        phoneCC: yup.string().required(),
        phone: yup.string().required()
        // confirmPassword: yup.string().required()
        // userName:yup.string().required(),
        // companyName:yup.string().required()
        //address: yup.string(),
    })
    .required();

const AdminFormRegistration = () => {
    const [showPassword, setShowPassword] = useState(false);

    const { data: dataRegister, status: statusUpdate, error: errorUpdate, sentCustomerCreate } = useCustomerCreate();

    // const { register: registerAccount } = useContext(JWTContext);
    const { registerSeller: registerAccount } = useContext(JWTContext);

    const location = useLocation();
    const navigate = useNavigate();

    const inputClass = (field) => `form-control border-0 border-bottom p-10 text-14 ${errors[field] ? 'is-invalid' : ''}`;

    const {
        control,
        register,
        handleSubmit,
        reset,

        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            phoneCC: '+62'
        }
    });

    const onSubmit = async (data) => {
        // console.log(data);

        try {
            // const result = await sentCustomerCreate({
            //     email: data.email,
            //     password: data.password,
            //     phoneNumber: data.phoneCC+data.phone
            // },
            // () => {
            //     Swal.fire({
            //     title: "Success",
            //     text: "Register successfully",
            //     icon: "success"
            //     });

            //     navigate("/registration-document-verification");
            // });

            const result = await registerAccount({
                email: data.email,
                password: data.password,
                phoneNumber: data.phone,
                // userName:data.email,
                fullName: data.email,
                companyName: ''
                // confirmPassword: data.password
            });

            if (result?.token != undefined && result?.user != undefined) {
                localStorage.setItem('serviceToken', result?.token);
                localStorage.setItem('user', JSON.stringify(result?.user));
                axios.defaults.headers.common.Authorization = `Bearer ${result?.token}`;
            } else {
                localStorage.removeItem('serviceToken');
                localStorage.removeItem('user');
                delete axios.defaults.headers.common.Authorization;
            }
            Swal.fire({
                title: 'Success',
                text: 'Register successfully',
                icon: 'success'
            });
            navigate(`/admin/register-seller-type`);
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: 'Error',
                text: err,
                icon: 'error'
            });
        }
    };

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    return (
        <>
            <section
                className="banner-form text_inter position-relative"
                style={
                    {
                        // backgroundImage:"url('/assets/images/profile_temp/bgheader.jpg')"
                    }
                }
            >
                <div className="bgHalf"></div>
                <div className="container h-100 z-3 position-relative">
                    <div className="row align-items-center h-100">
                        <div className="col-12 col-md-6">
                            <div className="p-20 ps-0">
                                <div className="">
                                    <span className="text_quicksand text-56 text-white fw-bold lh-40">Start Selling Today!</span>
                                </div>
                                <div className="">
                                    <span className="text-24 text-white fw-medium ">
                                        more than 100K+ stores around the world and go globally .
                                    </span>
                                </div>
                                <div className="mt-20 d-none">
                                    <span className="text-14 text-white lh_24">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                        aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                                        cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 formstyle">
                            <div className="p-20 px-0 ps-md-32 pe-md-0">
                                <div className="bg-white p-20 text_quicksand  mx-auto" style={{ borderRadius: '6px', maxWidth: '550px' }}>
                                    <h5 className="mb-52">Sign up as Seller Community</h5>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-group mb-24 d-none">
                                            <label className="fw-bold fs-14 fw-normal form-label">Choose Plan</label>
                                            {/* <select className="form-control text-14 p-10">
                                                    <option><span className="text-main-one-600">Business Plan</span> - $ 12.00/month</option>
                                                </select> */}
                                        </div>
                                        <div className="form-group mb-24">
                                            <input
                                                type="text"
                                                className={inputClass('email')}
                                                placeholder="Enter Email"
                                                {...register('email')}
                                            />
                                            {errors.email && <small className="text-danger">{errors.email.message}</small>}
                                        </div>
                                        <div className="form-group mb-24 password-switchable position-relative">
                                            {/* <input type="password" className="form-control border-0 border-bottom p-10  text-14" placeholder="Enter Password" {...register("password")}  /> */}
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className={inputClass('password')}
                                                placeholder="Enter Password"
                                                {...register('password')}
                                            />
                                            <div className="position-absolute top-0 end-0">
                                                <button type="button" className="btn" onClick={() => setShowPassword((prev) => !prev)}>
                                                    {showPassword ? (
                                                        <i className="ph-bold ph-eye-closed  text-black"></i>
                                                    ) : (
                                                        <i className="ph-bold ph-eye  text-black"></i>
                                                    )}
                                                </button>
                                                {/* <button type="button" className="btn open"><span className="text-black"><i className="ph-bold ph-eye"></i></span></button>
                                                    <button type="button" className="btn close d-none"><span className="text-black"><i className="ph-bold ph-eye-closed"></i></span></button> */}
                                            </div>
                                            {errors.password && <small className="text-danger">{errors.password.message}</small>}
                                        </div>
                                        {/* <div className="form-group mb-24 password-switchable position-relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className={inputClass("password")}
                                                    placeholder="Enter Password"
                                                    {...register("confirmPassword")}
                                                />
                                                <div className="position-absolute top-0 end-0">
                                                    <button
                                                    type="button"
                                                    className="btn"
                                                    onClick={() => setShowPassword(prev => !prev)}
                                                    >
                                                    {showPassword ? (
                                                        <i className="ph-bold ph-eye-closed  text-black"></i>
                                                    ) : (
                                                        <i className="ph-bold ph-eye  text-black"></i>
                                                    )}
                                                    </button>
                                                </div>
                                                 {errors.confirmPassword && (
                                                    <small className="text-danger">
                                                    {errors.confirmPassword.message}
                                                    </small>
                                                )}
                                            </div> */}
                                        <div className="form-group mb-24 composite mb-60">
                                            {/* <div className="border-bottom">
                                                    <div className="d-flex align-items-center">
                                                        <select className="form-control border-0 p-10 shadow-none  text-14" style={{width:"fit-content"}} {...register("phoneCC")} >
                                                            <option defaultValue="+62" value={"+62"}>+62</option>
                                                        </select>
                                                        <input type="text" className={inputClass("phone")} {...register("phone")} placeholder="Enter Phone Number"  />
                                                    </div>
                                                    
                                                </div>
                                                 {errors.phone && (
                                                    <small className="text-danger">
                                                    {errors.phone.message}
                                                    </small>
                                                )}  */}

                                            <Controller
                                                name="phone"
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <PhoneInput
                                                        {...field}
                                                        defaultCountry={DEFAULT_COUNTRY_CODE}
                                                        international
                                                        placeholder="Enter phone number"
                                                        className="form-control d-flex"
                                                    />
                                                )}
                                            />

                                            {errors.phone && <span className="text-danger text-sm">{errors.phone.message}</span>}
                                        </div>

                                        {/* <button className="btn btn_register font-14 fw-bold text_quicksand"  type="submit" onClick={() => navigate("/registration-document-verification")} >NEXT STEP</button> */}
                                        <button className="btn btn_register font-14 fw-bold text_quicksand" type="submit">
                                            NEXT STEP
                                        </button>
                                        {/* <div className="my-30 text-align mx-auto text-center" >
                                            or continue with
                                        </div>
                                        <button className="btn btn_register_google font-14 fw-bold text_quicksand" type="button" ><img width={"20px"} height={"20px"} src="/assets/images/logo/google_logo.png" /></button> */}
                                        <div className="my-30 text-align mx-auto text-center">
                                            Already have an account?{' '}
                                            <Link
                                                to={`/admin/login?redirect=${encodeURIComponent(redirectPath)}`}
                                                className="text-main-one-600"
                                            >
                                                Sign in
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AdminFormRegistration;
